module.exports = __webpack_public_path__ + "static/media/SPACE-BUSD.985ec829.png";